import * as React from 'react';

const SvgAlertTriangleOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M10.997 14.99h2l-.02-5h-2l.02 5ZM11.037 15.99h2v2h-2v-2Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m21.867 19.51-9-17a.987.987 0 0 0-.87-.51c-.34 0-.68.17-.87.51l-9 17c-.37.67.11 1.49.87 1.49h18c.76-.01 1.24-.83.87-1.49Zm-17.21-.52 7.34-13.86 7.34 13.86H4.657Z", fill: "currentColor" })));

export { SvgAlertTriangleOutline as default };
